import React, { useEffect, useState } from 'react'
import MasterService from '../Masters/MasterService'
import { currentTenant } from '../Common/Credentials'
import { TextField } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const Prefixsettings = () => {
    const navigate = useNavigate()
    const [prefixList,setPrefixList] = useState([])
    const [loading,setLoading] = useState(false)
    const [edit,setEdit] = useState(null)
    useEffect(()=>{
        FetchData()
    },[])

    const FetchData = () =>{
      if(prefixList.length ===0){
        setLoading(true)
        MasterService.getallprefixesofTenant(currentTenant).then(res=>{
            if(res.data && res.data.length >0){
              setPrefixList(res.data)
              setLoading(false)
            } else{
                MasterService.AddDefaultPrefixofTenant(currentTenant).then(()=>{
                  MasterService.getallprefixesofTenant(currentTenant).then(res=>{
                     if(res.data && res.data.length === 0){
                      setPrefixList(res.data)
                     }
                    setLoading(false)
                  })
                })   
            }
    }).catch(()=>setLoading(false))
    }
    }

    const updateCustprefix = () =>{
        navigate("/initialsetup")
    }

  return (
    loading?
    <div>
         <div className="form-group col-md-12 shadow-sm p-3 mb-5 bg-body rounded">
                      <div className="card-header text-center text-md text-bold textColour">
                        Prefix and Serial No. Settings
                      </div>
                      <div className="tw-px-md-5">
                      {prefixList.map((e,i)=>
                      <div className="row p-2 tw-px-md-5 tw-flex tw-justify-center" key={i}>
                         <div className="col-md-2">
                          <TextField
                            label=" "
                            value={e.type}
                            // onChange={(e) =>
                            //   this.setState({ customerprefix: e.target.value })
                            // }
                            disabled
                            variant='standard'
                            fullWidth
                          ></TextField>
                        </div>
                        <div className="col-md-1">
                          <TextField
                            label="Prefix"
                            value={e.prefix}
                            // onChange={(e) =>
                            //   this.setState({ customerprefix: e.target.value })
                            // }
                            // disabled={edit === i?false:true}
                            variant='standard'
                            fullWidth
                          ></TextField>
                        </div>
                        <div className="col-md-1">
                          <TextField
                            label="Serial No."
                            value={e.serialnum}
                            // onChange={(e) =>
                            //   this.setState({ customersno: e.target.value })
                            // }
                            // disabled={edit === i?false:true}
                            variant='standard'
                            fullWidth
                          ></TextField>
                        </div>
                        <div className="col-md-2">
                          <TextField
                            label="Customer Id"
                            value={
                              e.prefix +
                              "-" +
                              e.serialnum
                            }
                            disabled
                            variant='standard'
                            fullWidth
                          ></TextField>
                        </div>
                        {/* {edit === i ? (
                          <div className="col-md-1">
                            <button
                              className="btn btn-sm hovbuttonColour mt-3 fa fa-save"
                              // onClick={this.updateCustprefix}
                            ></button>
                          </div>
                        ) : e.activestatus === "ACTIVE" ? (
                          ""
                        ) : (
                          <div className="col-md-1">
                            <button
                              className="btn btn-sm hovbuttonColour mt-3 fa fa-edit"
                              onClick={()=>setEdit(i)}
                            ></button>
                          </div>
                        )} */}
                      </div>
                    )}
                     <div className="row p-2 tw-flex tw-justify-center">
                     <button
                              className="btn btn-sm hovbuttonColour mt-3"
                              onClick={updateCustprefix}
                            >Save</button>
                     </div>
                     </div>
                      </div>
    </div>
    :
    ""
  )
}

export default Prefixsettings